import { RouterParams } from './interfaces/IRouter';
import prouniPipeline from '@/pipeline/prouni';
import prouniStepRouteMapping from '@/pipeline/prouni/stepRouteMapping';
import prouniAuth from '@/helpers/prouniAuth';
import PROUNI_VIEWS_NAMES from '@/router/prouniViewsNames';

/**
 * Dedicated ProUni route guard. It enforces the ProUni pipeline order using the
 * INDEPENDENT ProUni interpreter, so the default enrollment-pipeline
 * enforcement in `router.beforeEach` is bypassed for ProUni routes.
 *
 * - Unauthenticated candidates are redirected to the ProUni start screen
 *   (which opens the pocket login iframe).
 * - When the pipeline is running, only the current step route is reachable;
 *   any other pipeline route delegates "back" to the pipeline.
 */
const prouniMiddleware = ({ to, from, next }: RouterParams) => {
  if (!prouniAuth.isLogged()) {
    if (to.name === PROUNI_VIEWS_NAMES.PROUNI_START) return next();
    return next({ name: PROUNI_VIEWS_NAMES.PROUNI_START });
  }

  const isPipelineRoute = Object.values(prouniStepRouteMapping).includes(to.name || '');

  if (!isPipelineRoute) return next();

  if (!prouniPipeline.initialized) {
    return next({ name: PROUNI_VIEWS_NAMES.PROUNI_START });
  }

  const currentStepRoute = prouniStepRouteMapping[prouniPipeline.currentStep];

  if (currentStepRoute === to.name) return next();

  next(from.path);
  return prouniPipeline.prev();
};

export { prouniMiddleware };
